import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './OwnerTags.APP_TARGET.scss';
import { FormattedMessage as Translation } from 'react-intl';
import { fileNames } from 'Constants/imageUrls';
import { isCocoFofoUser, isFofoUser } from 'Helpers/item';
import { XX, WEBP_SVG_TYPE, X, WEBP_PNG_TYPE } from 'Constants/images';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { connect } from 'react-redux';
import { getAuthorisedDealerTxt } from 'Selectors/config';
import withConfig from 'HOCs/withConfig/withConfig';
import { CONFIG } from 'Constants/config';
import { FEATURED_TAG } from 'Components/Listing/components/constants';
import { isSpotLight } from 'Helpers/adActionStatus';
import DiscountBadge from 'Components/DiscountBadge/DiscountBadge';
import { isMobile } from 'Helpers/devices';
import MembershipTagV1 from 'Components/MembershipTagV1/MembershipTagV1';

export const OwnerTags = ({
    appliedPackage,
    monetizationInfo,
    user,
    isVerifiedSeller,
    authorisedDealerTxt,
    config,
    hasPromotion,
    discountPrice,
    MembershipTag
}) => {
    const isFeatured = (appliedPackage && (appliedPackage.id || appliedPackage.name))
        || monetizationInfo?.currentProduct;
    const isCocoItem = isCocoFofoUser(user);
    const hideOlxAutosTagAdpv = config.get('adpvAuto', 'hideOlxAutosTagAdpv');
    const staticAssetUrl = config.get(CONFIG.STATIC_ASSETS);

    if (!isFeatured && !isCocoItem && !isFofoUser(user) && (isCocoFofoUser(user) || !isVerifiedSeller) && !hasPromotion && !MembershipTag) {
        return null;
    }
    const brandLogo = config.get('brandLogo');
    let statusTag;
    let isDiscount;
    let isMembership;

    if (isSpotLight(monetizationInfo)) {
        statusTag = (
            <ImageWrapper
                fileName={ fileNames.SPOTLIGHT_BADGE }
                types={ WEBP_PNG_TYPE }
                className={ classNames(css.statusTag, css.spotlightBadge) }
                data-aut-id="spotlightBadge"
            />
        );
    }
    else if (isFeatured) {
        statusTag = (
            <span className={ classNames(css.statusTag, css.featuredTag) }>
                <img src={ `${staticAssetUrl}${FEATURED_TAG.IMAGE}` } alt={ FEATURED_TAG.ALT } />
                <Translation id="listing_ad_featured_label" />
            </span>);
    }
    else if (isCocoItem && !hideOlxAutosTagAdpv) {
        statusTag = (
            <span
                className={ classNames(css.statusTag, css.olxAutosTag) }
                data-test-id="olx-autos-tag"
            >
                <ImageWrapper
                    fileName={ brandLogo }
                    fileSize={ XX }
                    className={ isCocoItem ? css.autosTag : css.inspectedTag }
                    alt="Olx Autos Tag"
                    types={ WEBP_SVG_TYPE }
                />
            </span>
        );
    }
    if (hasPromotion) {
        isDiscount = (
            <>
                <DiscountBadge className={ css.discountBadgeClassName } size={ isMobile ? 'md' : 'lg' } discountText={ `DISKON ${discountPrice || '-'}` } />
            </>
        );
    }
    if (MembershipTag) {
        isMembership = (
            <>
                <MembershipTagV1
                    type={ user?.subscription_info?.type || '' }
                    containerClassName={ css.containerClassName }
                    textClassName={ css.textClassName }
                    iconClassName={ css.iconClassName }
                />
            </>
        );
    }

    return (
        <div className={ css.ownerTags }>
            {isMembership}
            {statusTag}
            {isDiscount}
            {
                isFofoUser(user) && <span className={ classNames(css.statusTag, css.approvedDealerTag) }>
                    {authorisedDealerTxt}
                </span>
            }
            {
                !isCocoFofoUser(user)
                    && isVerifiedSeller
                    && <span className={ classNames(css.statusTag, css.verifiedSellerTag) }>
                        <ImageWrapper
                            fileName={ fileNames.VERIFIED_USER }
                            fileSize={ X }
                            className={ css.verifiedSellerIcn }
                            alt="verified seller"
                            types={ WEBP_SVG_TYPE }
                        />
                        <Translation id="dealerVerifiedSeller" />
                    </span>
            }
        </div>
    );
};

OwnerTags.propTypes = {
    appliedPackage: PropTypes.object,
    monetizationInfo: PropTypes.object,
    user: PropTypes.object,
    isVerifiedSeller: PropTypes.bool,
    authorisedDealerTxt: PropTypes.string,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    hasPromotion: PropTypes.bool,
    discountPrice: PropTypes.string,
    MembershipTag: PropTypes.bool
};

OwnerTags.defaultProps = {
    isVerifiedSeller: false
};

const mapStateToProps = state => ({
    authorisedDealerTxt: getAuthorisedDealerTxt(state)
});

export default withConfig(connect(mapStateToProps)(OwnerTags));
